/**
 * Custom Login Page — mirrors `Notify_Angular_Reference`'s `LoginComponent.ngOnInit`:
 *   - If the SSO session is alive, navigate to /apps/accounts.
 *   - Otherwise clear storage and redirect to the corporate portal.
 */

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import sso from "@/auth/sso";
import { clearAuthData } from "@/auth/authSync";

const PORTAL_URL =
  import.meta.env.VITE_PORTAL_URL ?? "https://portal.roommatik.com";

const CustomLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  useEffect(() => {
    if (sso.authenticated) {
      navigate("/apps/accounts", { replace: true });
    } else {
      clearAuthData();
      window.location.href = PORTAL_URL;
    }
  }, [navigate]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: isDark
          ? `linear-gradient(to right, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`
          : "linear-gradient(to right, #ffffff 0%, #e3f6f7 100%)",
        gap: 2,
      }}
    >
      <CircularProgress sx={{ color: theme.palette.primary.main }} />
      <Typography variant="body2" sx={{ color: theme.palette.text.primary }}>
        Redirecting…
      </Typography>
    </Box>
  );
};

export default CustomLoginPage;
